<script setup lang="ts">
import Accordeon, { type AccordeonEmits } from '@/components/Accordion/index.vue'
import { useElementalListsStore } from '~~/src/stores/useElementalListsStore'
import TableRowElementalItem from '@/components/Library/TableLibrary/TableRowElementalItem/index.vue'
import IconBox from '@/components/DrawerSidebarRight/components/shared/IconBox.vue'
import TableAccordeonTrigger from '@/components/Library/TableLibrary/TableAccordeonTrigger/index.vue'
import TableRowSkeleton from '@/components/Library/TableLibrary/TableRowSkeleton/index.vue'

const emits = defineEmits<AccordeonEmits>()
const { elementalsFiltered, isLoading, refetch } = useRecentElementals()

const user = useUser()
const { state, toggleRecentAccordion } = useElementalListsStore()

const handleClose = () => {
  toggleRecentAccordion(false)
}

const handlerOpen = () => {
  toggleRecentAccordion(true)
}
const accordionRef = ref()

const handleToggle = (isOpen?: boolean) => {
  emits('onToggle', isOpen)
}

onMounted(() => {
  refetch()
})
</script>

<template>
  <div v-if="user">
    <Accordeon
      ref="accordionRef"
      :is-open="state.recentAccordionOpen"
      :ignore-events="state.query !== ''"
      @on-close="handleClose"
      @on-open="handlerOpen"
      @on-toggle="handleToggle($event)"
    >
      <template #header>
        <button
          class="w-full"
          @click="() => accordionRef?.toggle()"
        >
          <TableAccordeonTrigger title="Recents" class="border-grayLighter border-b">
            <template #icon>
              <IconBox
                class="bg-gray-300 h-7 w-7"
              >
                <span class="text-dark-gray flex-shrink-0 h-6" i-mdi:clock-outline />
              </IconBox>
            </template>
          </TableAccordeonTrigger>
        </button>
      </template>
      <template #content>
        <div v-if="elementalsFiltered && elementalsFiltered?.length > 0">
          <TableRowElementalItem
            v-for="list in elementalsFiltered.slice(0, 5)"
            :key="`recent-elemental-${list.id}-${list.title}`"
            :elemental="{
              ...list,
              id: list.isList ? list.id_list.toString() : list.id,
            }"
            :columns="['title']"
            :folder-level="1"
            row-class="!pl-8"
            elemental-label="Recents"
          />
        </div>
        <div v-else-if="isLoading" class="animate-pulse grid gap-0.5 rounded-md bg-white">
          <div v-for="n in 5" :key="`skeleton-${n}`">
            <TableRowSkeleton :columns="['title']" :folder-level="1" />
          </div>
        </div>
        <div v-else class="text-center space-y-4 p-4 bg-[#F6F6FF]">
          <p class="text-gray-500 text-sm">
            No recent items
          </p>
        </div>
      </template>
    </Accordeon>
  </div>
</template>

<style lang="css" module>
  .boxColors {
  }
</style>

<style module lang="css">
.arrow_icon {
      @apply w-9 h-9 text-dark-gray;
      transition: transform 0.3s ease-in-out;
      pointer-events: none !important;
    }
</style>
